<template>
  <div>
    <!--广告-->
    <index-rotation-ad v-if="$root.adList.indexRotationAd && $root.adList.indexRotationAd.length>0"/>
    <div style="margin-top: 0.08rem;margin-bottom: 0.08rem;" v-if="$root.adList.icoAd && $root.adList.icoAd.length>0">
      <ico-ad/>
    </div>
    <index-banner-ad v-if="$root.adList.indexBannerAd && $root.adList.indexBannerAd.length>0"/>
    <!--免费视频-->
    <div style="margin-top: 0.05rem;">
      <div class="itemCenter">
        <svg t="1657163989249" class="icon" viewBox="0 0 1024 1024" version="1.1"
             xmlns="http://www.w3.org/2000/svg" p-id="9566" height="33">
          <path
              d="M102.4 102.4m307.2 0l204.8 0q307.2 0 307.2 307.2l0 204.8q0 307.2-307.2 307.2l-204.8 0q-307.2 0-307.2-307.2l0-204.8q0-307.2 307.2-307.2Z"
              fill="#F54B65" fill-opacity=".2" p-id="9567"></path>
          <path
              d="M391.168 328.88832l372.44928 72.3968a40.96 40.96 0 0 1 32.38912 48.0256l-46.36672 238.56128a40.96 40.96 0 0 1-48.0256 32.39936L329.30816 647.8848a40.96 40.96 0 0 1-28.24192-20.7872l-66.9696-124.39552a61.44 61.44 0 0 1 15.1552-76.63616l108.1344-88.65792a40.96 40.96 0 0 1 33.77152-8.52992zM284.9792 473.76384a38.22592 38.22592 0 1 0 75.04896 14.592 38.22592 38.22592 0 0 0-75.0592-14.592z"
              fill="#F54B65" fill-opacity=".6" p-id="9568"></path>
          <path
              d="M740.8128 317.44a40.96 40.96 0 0 1 40.96 40.96v243.02592a40.96 40.96 0 0 1-40.96 40.96H361.54368a40.96 40.96 0 0 1-31.6928-15.01184L240.384 518.0416a61.44 61.44 0 0 1 0.24576-78.12096l89.22112-107.65312A40.96 40.96 0 0 1 361.39008 317.44h379.42272z m-417.792 124.24192a38.22592 38.22592 0 1 0 0 76.46208 38.22592 38.22592 0 0 0 0-76.46208z"
              fill="#F54B65" p-id="9569"></path>
        </svg>
        <div style="font-size: 18px;">
          免费试看
        </div>

      </div>
      <div class="videoListBox">
        <van-empty v-if="videoFreeList.length<1" description="资源加载中..."/>
        <div class="itemCenter">
          <div @click="videoInfo(video.id)" class="videoItemBox videoItemMain"
               v-for="video in videoFreeList">
            <div style="padding: 5px;width: 100%;box-sizing:border-box;">
              <div class="defaultImg"
                   :style="{backgroundImage:'url('+require('@/assets/img/defaultImg.gif')+')',backgroundSize:'100% 100%'}">
                <div style="height: 230px" class="videoImgBox"
                     v-bind:style="{backgroundImage:'url('+video.coverUrl+')',backgroundSize:'100% 100%'}"
                >
                  <!-- 遮罩 -->
                  <div class="playBoxShow" style="height: 230px;">
                    <van-button type="warning" icon="play-circle-o">立即观看</van-button>
                  </div>
                </div>
              </div>
              <div class="videoTitle">
                {{ video.title }}
              </div>
              <div style="margin-top: 5px;display: flex;align-items: center;">
                <div class="videoPlayInfo" v-if="$root.playIsShow">
                  <van-icon name="video-o"/>
                  {{ video.playCount }}
                </div>
                <div class="videoDateInfo">
                  <van-icon name="bars"/>
                  {{ video.videoTag }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div>
      <div class="itemCenter">
        <div>
          <div class="itemCenter" style="padding-top: 15px;">
            <svg t="1657163989249" class="icon" viewBox="0 0 1024 1024" version="1.1"
                 xmlns="http://www.w3.org/2000/svg" p-id="9566" height="33">
              <path
                  d="M102.4 102.4m307.2 0l204.8 0q307.2 0 307.2 307.2l0 204.8q0 307.2-307.2 307.2l-204.8 0q-307.2 0-307.2-307.2l0-204.8q0-307.2 307.2-307.2Z"
                  fill="#F54B65" fill-opacity=".2" p-id="9567"></path>
              <path
                  d="M391.168 328.88832l372.44928 72.3968a40.96 40.96 0 0 1 32.38912 48.0256l-46.36672 238.56128a40.96 40.96 0 0 1-48.0256 32.39936L329.30816 647.8848a40.96 40.96 0 0 1-28.24192-20.7872l-66.9696-124.39552a61.44 61.44 0 0 1 15.1552-76.63616l108.1344-88.65792a40.96 40.96 0 0 1 33.77152-8.52992zM284.9792 473.76384a38.22592 38.22592 0 1 0 75.04896 14.592 38.22592 38.22592 0 0 0-75.0592-14.592z"
                  fill="#F54B65" fill-opacity=".6" p-id="9568"></path>
              <path
                  d="M740.8128 317.44a40.96 40.96 0 0 1 40.96 40.96v243.02592a40.96 40.96 0 0 1-40.96 40.96H361.54368a40.96 40.96 0 0 1-31.6928-15.01184L240.384 518.0416a61.44 61.44 0 0 1 0.24576-78.12096l89.22112-107.65312A40.96 40.96 0 0 1 361.39008 317.44h379.42272z m-417.792 124.24192a38.22592 38.22592 0 1 0 0 76.46208 38.22592 38.22592 0 0 0 0-76.46208z"
                  fill="#F54B65" p-id="9569"></path>
            </svg>
            <div style="font-size: 18px;">
              热播视频
            </div>
          </div>
        </div>
        <div style="text-align: right;flex: 1;" v-if="videoList && videoList.length>=25">
          <van-button @click="++pageNumber;getVideoList();" style="background-color: #282b35;color: #ffffff;border: 0;"
                      type="default" icon="replay" size="small">换一批
          </van-button>
        </div>
      </div>
      <div class="videoListBox">
        <van-empty v-if="videoList.length<1" description="资源加载中..."/>
        <div style="display: flex;align-items: center;flex-wrap: wrap;">
          <div @click="videoInfo(video.id)" class="videoItemBox videoItemMain"
               v-for="video in videoList">
            <div style="padding: 5px;width: 100%;box-sizing:border-box">
              <div class="defaultImg"
                   :style="{backgroundImage:'url('+require('@/assets/img/defaultImg.gif')+')',backgroundSize:'100% 100%'}">
                <div style="height: 230px" class="videoImgBox"
                     v-bind:style="{backgroundImage:'url('+video.coverUrl+')',backgroundSize:'100% 100%'}"
                >
                  <!-- 遮罩 -->
                  <div class="playBoxShow" style="height: 230px;">
                    <van-button type="warning" icon="play-circle-o">立即观看</van-button>
                  </div>
                </div>
              </div>
              <div class="videoTitle">
                {{ video.title }}
              </div>
              <div style="margin-top: 5px;display: flex;align-items: center;">
                <div class="videoPlayInfo" v-if="$root.playIsShow">
                  <van-icon name="video-o"/>
                  {{ video.playCount }}
                </div>
                <div class="videoDateInfo">
                  <van-icon name="bars"/>
                  {{ video.videoTag }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import PcNav from "@/components/pc/pcNav";
import request from "@/utils/request";
import IcoAd from "@/components/pc/icoAd.vue";
import IndexBannerAd from "@/components/pc/indexBannerAd.vue";
import IndexRotationAd from "@/components/pc/indexRotationAd.vue";

export default {
  name: "index",
  components: {IndexRotationAd, IndexBannerAd, IcoAd, PcNav},
  data() {
    return {
      superiorId: '',
      pageNumber: 1,
      videoFreeList: [],
      videoList: [],
    }
  }, mounted() {
    let superiorId = this.$route.query.superiorId;
    if (superiorId) {
      this.superiorId = superiorId;
      localStorage.setItem("superiorId", this.superiorId);
    }
    this.getFreeVideo();
    this.getVideoList();


  }, methods: {
    videoInfo(videoId) {
      window.scrollTo(0, 0);
      this.$router.push({path: "/videoInfo", query: {videoId: videoId}})
    },
    getFreeVideo() {
      request.get('/view/getFreeVideo').then(res => {
        this.videoFreeList = res.data;
      })
    },
    getVideoList() {
      request.get('/view/getVideoList/' + this.pageNumber).then(res => {
        this.videoList = res.data;
      })
    },
  },
}
</script>

<style scoped>
.videoBox {
  display: flex;
  margin-top: 10px;
  align-items: center;
  font-size: 15px;
}

.rightText {
  font-size: 3px;
  color: #CCCCCC;
  cursor: pointer;
  background-color: #282B35;
  border-radius: 3px;
  padding: 5px;
}

.rightText:hover {
  color: #e0dfdf;
  background-color: #464a58;
}


.rightTextBox {
  margin-top: 15px;
  text-align: right
}


</style>